module.exports = __webpack_public_path__ + "bec72b31668f9a717fbccf957f54ef6c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/5.jpg
 ** module id = 215
 ** module chunks = 0
 **/